import { useState } from 'react';
import { FormControl, Stack, FormLabel } from '@chakra-ui/react';
import { Field } from 'formik';
import NameField from 'components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackSpacing, formLabelStyling, stackStyling } from 'components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';

const PlanPrefixField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.countryPrefix && touched.countryPrefix}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()} >
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Prefix <span style={{ color: '#e53e3e' }}>*</span>
                </FormLabel>
                <Field
                    as={NameField}
                    id="countryPrefix"
                    name="countryPrefix"
                    data-walkthroughid={walkthroughIds.plans.ufPrefixInput}
                    validate={value => !value ? 'Prefix is required' : undefined}
                    error={errors.countryPrefix}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Prefix for this plan."
                        ariaLabel="plan-prefix-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PlanPrefixField;
